import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

// Dependency-free checkbox (the app's Switch is likewise not Radix-based).
// Controlled via `checked` / `onCheckedChange`, matching the shadcn API.
const Checkbox = React.forwardRef(
  ({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        role="checkbox"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onCheckedChange?.(!checked)}
        className={cn(
          'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-border/70 ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          checked && 'border-primary bg-primary text-primary-foreground',
          className
        )}
        {...props}
      >
        {checked && <Check className="h-3.5 w-3.5" />}
      </button>
    );
  }
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };
